import aggregatedQuery from './aggregatedQuery';

export default aggregatedQuery;
